module.exports = __webpack_public_path__ + "img/pause.34969366.svg";